<template>
  <div id="registration-questions">
    <!-- Single line text (Default: 10, Name: 1000, LastName: 10001, Title: 4, Instituon: 33, School: 5, State: 28, City:9, Postal Code: 29, Address line: 30, HES Code: 31), Department: 34 -->
    <div class="registration-question" v-if="question.type == 10 || question.type == 34 || question.type == 3 || question.type == 1000 || question.type == 10001 || question.type == 4 || question.type == 33 || question.type == 5 || question.type == 28 || question.type == 9 || question.type == 29 || question.type == 30 || question.type == 31">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-input v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" :minlength="question.minCharAllowed" :maxlength="question.maxCharAllowed" :show-word-limit="question.showLimit" clearable></el-input>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Multi line text (Default: 11) -->
    <div class="registration-question" v-if="question.type == 11">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-input type="textarea" v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" :minlength="question.minCharAllowed" :maxlength="question.maxCharAllowed" :rows="question.rows" :show-word-limit="question.showLimit" clearable></el-input>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Email (Default: 12, Unique Email: 1) -->
    <div class="registration-question" v-if="question.type == 12 || question.type == 1">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-input suffix-icon="fas fa-pen" v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" minlength="5" maxlength="250" clearable></el-input>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Phone (Default: 13, Unique Mobile: 2, Mobile Phone: 25, Work Phone: 26) -->
    <div class="registration-question" v-if="question.type == 13 || question.type == 2 || question.type == 26 || question.type == 27">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <VuePhoneNumberInput :no-use-browser-locale="phoneNumber ? true : false" :fetch-country="false" :default-country-code="phoneNumber ? null : 'TR'" :required="question.isRequired" v-model="phoneNumber" @update="updatePhoneNumber" :placeholder="question.placeholder" clearable />
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Number (Default: 14) -->
    <div class="registration-question" v-if="question.type == 14">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-input-number v-model="question.answer" :required="question.isRequired" :min="question.minValue" :max="question.maxvalue" :step="question.step" step-strictly></el-input-number>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Multiple choice question (Default: 100) -->
    <div class="registration-question" v-if="question.type == 100 && registrationForm != null">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <div class="choice-questions">
        <el-checkbox :checked="question.answers.some(x => x == option.id)" v-for="(option, index) in question.options" :key="option.id + index" :label="option.id" @change="changeAnswers(option.id)">
          {{ option.title }}
          <template v-if="option.price">({{ (option.price >= 0 ? "+" : "-") + $currency.format(option.price, { code: $parseCurrency(registrationForm.paymentInfo.currency) }) }})</template>
        </el-checkbox>
      </div>
      <span class="hint-text">{{ question.hint }}</span>
      <QuestionValidation :errorKey="baseValidationKey + question.id" />
    </div>

    <!-- Single choice question (Default: 15) -->
    <div class="registration-question" v-if="question.type == 15">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <div class="choice-questions">
        <el-radio v-model="question.answer" :label="options.id" v-for="(options, index) in question.options" :key="index">
          {{ options.title }}
          <template v-if="options.price > 0">({{ (options.price >= 0 ? "+" : "-") + $currency.format(options.price, { code: $parseCurrency(registrationForm.paymentInfo.currency) }) }})</template>
        </el-radio>
      </div>
      <span class="hint-text">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Select dropdown (Default: 16) -->
    <div class="registration-question" v-if="question.type == 16">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-select v-model="question.answer" :multiple="question.allowMultipleSelections" :filterable="question.addSearchbox" :placeholder="question.placeholder">
        <el-option v-for="(options, index) in question.options" :key="index" :label="options.title + (options.price > 0 ? ' (+' + $currency.format(options.price, { code: $parseCurrency(registrationForm.paymentInfo.currency) }) + ')' : '')" :value="options.id"></el-option>
      </el-select>
      <span class="hint-text">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Country select (Default: 8) -->
    <div class="registration-question" v-if="question.type == 8">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-select v-model="question.answer" filterable :placeholder="question.placeholder" :required="question.isRequired">
        <el-option required v-for="item in countryList" :key="item.index" :label="item.name" :value="item.name" clearable>
          <div class="custom-option">
            <!-- <img :src="require('../../assets/flags/' + item.flag_1x1)" /> -->
            <span>{{ item.name }}</span>
          </div>
        </el-option>
      </el-select>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Date picker (Default: 101) -->
    <div class="registration-question" v-if="question.type == 101">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-date-picker v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" :format="question.format" clearable></el-date-picker>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Time picker (Default: 102) -->
    <div class="registration-question" v-if="question.type == 102">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-time-picker v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" :format="'HH:mm'" clearable></el-time-picker>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Star rating (Default: 200) -->
    <div class="registration-question" v-if="question.type == 200">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <div class="rate-container">
        <el-rate v-model="question.answer"></el-rate>
      </div>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Emotion rating (Default: 201) -->
    <div class="registration-question" v-if="question.type == 201">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <div class="rate-container">
        <el-rate v-model="question.answer" :icon-classes="['far fa-frown', 'far fa-meh', 'far fa-smile']" void-icon-class="far fa-meh" :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
      </div>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Slider rating (Default: 202) -->
    <div class="registration-question" v-if="question.type == 202">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <div class="rate-container px-2">
        <el-slider v-model="question.answer" input-size="small" :min="question.minValue" :max="question.maxValue" :step="question.step"></el-slider>
      </div>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Info block (Default: 500) -->
    <div class="registration-question" v-if="question.type == 500">
      <el-alert v-if="question.color == 1" :title="question.title" type="success" show-icon></el-alert>
      <el-alert v-if="question.color == 2" :title="question.title" type="info" show-icon></el-alert>
      <el-alert v-if="question.color == 3" :title="question.title" type="warning" show-icon></el-alert>
      <el-alert v-if="question.color == 4" :title="question.title" type="error" show-icon></el-alert>
    </div>

    <!-- File upload (Default: 104, Photo: 32) -->
    <div class="registration-question" v-if="question.type == 104 || question.type == 32">
      <div class="sub-title">
        {{ question.title }}
        <span v-show="question.isRequired">*</span>
      </div>
      <el-upload
        :file-list="this.question.answers.map(x => ({ name: getFileNameFromUrl(x), url: x }))"
        :action="axios.defaults.baseURL + 'event/uploadfile?uploadType=registrationForm&registrationFormId=' + this.registrationForm.id + '&questionId=' + this.question.id"
        :headers="{ Authorization: axios.defaults.headers['Authorization'] }"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-remove="uploadRemoved"
        class="upload-registration"
        :class="question.type == 32 ? 'profile-picture-upload' : ''"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <template v-if="$i18n.locale == 'tr'">
          <div class="el-upload__text">
            Yüklemek için sürükle veya
            <em>tıkla.</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            <b>{{ question.maxSize }}</b>
            mb boyutundan küçük
            <b>{{ question.fileTypes }}</b>
            dosya yükleyiniz.
          </div>
        </template>
        <template v-else>
          <div class="el-upload__text">
            Drag or
            <em>click to install.</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            <b>{{ question.fileTypes }}</b>
            files with a size less than
            <b>{{ question.maxSize }}mb</b>
            .
          </div>
        </template>
      </el-upload>
      <span class="hint-text" v-if="question.hint != null && question.hint != ''">{{ question.hint }}</span>
      <QuestionValidation :validKey="baseValidationKey + question.id" />
    </div>

    <!-- Rich text editor (Default: 103) -->
    <!-- Rich text editor (Şimdilik iptal) -->

    <template v-if="question.answer != null && availableQuestions">
      <RecursiveQuestionBuilder :registrationForm="registrationForm" v-for="(question2, index) in availableQuestions.filter(x => x.parentAnswerId == question.answer)" :key="availableQuestions.length + index + Math.random(100000).toString()" :question="question2" :allQuestions="allQuestions" :availableQuestions="availableQuestions" :baseValidationKey="baseValidationKey" />
    </template>
    <template v-if="question.answers.length > 0 && availableQuestions">
      <RecursiveQuestionBuilder :registrationForm="registrationForm" v-for="(question2, index) in this.availableQuestions.filter(({ parentAnswerId }) => this.question.answers.includes(parentAnswerId))" :key="availableQuestions.length + index + Math.random(100000).toString()" :question="question2" :allQuestions="allQuestions" :availableQuestions="availableQuestions" :baseValidationKey="baseValidationKey" />
    </template>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import QuestionValidation from "./QuestionValidation.vue";
import countryList from "../../helpers/countryList.json";
import axios from "axios";
export default {
  components: { VuePhoneNumberInput, QuestionValidation },
  name: "RecursiveQuestionBuilder",
  props: ["question", "baseId", "baseValidationKey", "allQuestions", "availableQuestions", "registrationForm","form"],
  data() {
    return {
      phoneNumber: null,
      countryList,
      axios,
      phoneNumberObject: null
    };
  },
  created() {
    this.phoneNumber = this.question.answer;
    if (this.question.answers == null) {
      this.question.answers = [];
    }
    if (this.question.type == 202 && this.question.answer != null) {
      this.question.initialValue = parseInt(this.question.answer);
      this.question.answer = parseInt(this.question.answer);
    }
    if (this.question.answer != null && (this.question.type == 15 || this.question.type == 16)) {
      var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == this.question.answer);
      if (subQuestions.length > 0) {
        for (let index = 0; index < subQuestions.length; index++) {
          const element = subQuestions[index];
          if (!this.availableQuestions.some(x => x.id == element.id)) {
            this.availableQuestions.push(element);
          }
        }
      }
    }
    if (this.question.answers.length > 0) {
      this.loadAnswersQuestions();
    }
  },
  methods: {
    availableQuestions2() {
      return;
    },
    getFileNameFromUrl(url) {
      if (!url) return "";
      let split = url.split("/");
      return split[split.length - 1];
    },
    uploadSuccess(response) {
      if (response.hasError) {
        this.$message.error(response.message);
      } else {
        this.$message.success(response.message);
        this.question.answers.push(response.data.item.url);
      }
    },
    uploadRemoved(file, fileList) {
      this.question.answers = fileList.map(x => x.url);
    },
    uploadError(response) {
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      }
    },
    updateRate(number) {
      this.question.answer = number.toString();
    },
    updateSlider(number) {
      this.question.initialValue = number;
      this.question.answer = number.toString();
    },
    updatePhoneNumber(payload) {
      this.$nextTick(() => {
        this.phoneNumberObject = payload;
      });
      this.$nextTick(() => {
        this.question.answer = this.phoneNumberObject.formattedNumber;
      });
      this.$forceUpdate();
    },
    changeAnswers(id) {
      if (this.question.answers.some(x => x == id)) {
        var cIndex = this.question.answers.findIndex(x => x == id);
        if (cIndex != -1) {
          this.question.answers.splice(cIndex, 1);
        }
      } else {
        this.question.answers.push(id);
      }
    },
    loadAnswersQuestions() {
      this.question.answers.map(newValAnswer => {
        var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == newValAnswer);
        if (subQuestions.length > 0) {
          for (let index = 0; index < subQuestions.length; index++) {
            const element = subQuestions[index];
            if (!this.availableQuestions.some(x => x.id == element.id)) {
              this.availableQuestions.push(element);
            }
          }
        }
      });
    }
  },
  computed: {
    answer_str() {
      return JSON.parse(JSON.stringify(this.question.answers));
    },
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },

  watch: {
    answer_str: function(newValue_str, oldValue_str) {
      let newValue = newValue_str;
      let oldValue = oldValue_str;
      if (oldValue != null) {
        oldValue.map(oldValAnswer => {
          var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == oldValAnswer);
          if (subQuestions.length > 0) {
            for (let index = 0; index < subQuestions.length; index++) {
              const element = subQuestions[index];
              var indexx = this.availableQuestions.findIndex(x => x.id == element.id);
              if (indexx != -1) {
                this.availableQuestions.splice(indexx, 1);
              }
            }
          }
        });
      }
      if (newValue != null) {
        newValue.map(newValAnswer => {
          var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == newValAnswer);
          if (subQuestions.length > 0) {
            for (let index = 0; index < subQuestions.length; index++) {
              const element = subQuestions[index];

              if (!this.availableQuestions.some(x => x.id == element.id)) {
                this.availableQuestions.push(element);
              }
            }
          }
        });
      }

      // var temp = [];
      // for (let index = 0; index < this.availableQuestions.length; index++) {
      //   const element = array[index];
      //   if(!temp.some(x => x.id == element.id))
      //   {
      //     temp.push(element);
      //   }
      // }
      // this.availableQuestions = temp;
    },
    "question.answer": function(newVal, oldVal) {
      if (oldVal != null && !this.question.allowMultipleSelections && (this.question.type == 15 || this.question.type == 16)) {
        var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == oldVal);
        if (subQuestions.length > 0) {
          for (let index = 0; index < subQuestions.length; index++) {
            const element = subQuestions[index];
            var indexx = this.availableQuestions.findIndex(x => x.id == element.id);
            if (indexx != -1) {
              this.availableQuestions.splice(indexx, 1);
            }
          }
        }
      }

      if (newVal != null && !this.question.allowMultipleSelections && (this.question.type == 15 || this.question.type == 16)) {
        var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == newVal);
        if (subQuestions.length > 0) {
          for (let index = 0; index < subQuestions.length; index++) {
            const element = subQuestions[index];
            if (!this.availableQuestions.some(x => x.id == element.id)) {
              element.answer = null;
              this.availableQuestions.push(element);
            }
          }
        }
      }

      // var temp = [];
      // for (let index = 0; index < this.availableQuestions.length; index++) {
      //   const element = array[index];
      //   if(!temp.some(x => x.id == element.id))
      //   {
      //     temp.push(element);
      //   }
      // }
      // this.availableQuestions = temp;
    }
  }
};
</script>

<style lang="less">
#registration-questions {
  @primary-color: #268ea6;
  @danger-color: #ff6565;
  @warning-color: #f69656;
  @success-color: #50bfbf;
  @black-color: #292f3b;
  @soft-black-color: #505763;
  @gray-color: #8c929c;
  @white-color: white;
  @border-frame-color: #f1f1f1;
  @soft-background-color: #f1f3f6;
  @dark-background-color: #e8ebef;
  @dark-border-color: #dee2e7;
  @light-border-color: #e8ebef;
  @custom-background-color: #fbfbfb;
  @custom-border-color: #f1f3f6;
  @passive-background-color: #fff2f2;
  @active-background-color: #e5f7fb;

  .vue-phone-number-input {
    .select-country-container {
      .country-selector {
        display: flex;
        align-items: center;

        &.is-valid {
          input {
            border-color: @primary-color !important;
          }

          &:hover {
            input {
              border-color: @primary-color !important;
            }
          }
        }

        &.is-focused {
          .country-selector__input {
            box-shadow: unset !important;
            border-color: @primary-color !important;
            border: 1px solid;
          }

          &:hover {
            .country-selector__input {
              border-color: @primary-color !important;
            }
          }
        }

        &:hover {
          .country-selector__input {
            border-color: #c0c4cc !important;
          }
        }
        .country-selector__label {
          display: none;
        }
        .country-selector__country-flag {
          margin: auto 0;
          position: absolute;
          top: unset;
          left: 12px;
          z-index: 1;
          cursor: pointer;
          border-radius: 3px;
          overflow: hidden;
        }
        .country-selector__input {
          border-top-left-radius: 8px !important;
          border-bottom-left-radius: 8px !important;
          border: 1px solid #dcdfe6;
          background-color: #fbfbfb;
          padding: 10px 30px 10px 38px !important;
          transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
        .country-selector__toggle {
          color: #c0c4cc;
          opacity: 0.4;
        }

        .country-selector__list {
          position: absolute;
          z-index: 1002 !important;
          border: 1px solid #e4e7ed;
          border-radius: 8px !important;
          background-color: #fbfbfb;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          box-sizing: border-box;
          margin: 5px 0;
          top: 46px;

          button {
            &.selected {
              background-color: #f5f7fa !important;
              &:hover {
                background-color: #f5f7fa !important;
              }
              .dots-text {
                color: @black-color !important;
              }
            }

            &:hover {
              background-color: #f5f7fa !important;
            }

            .country-selector__list__item__flag-container {
              .iti-flag-small {
                border-radius: 3px;
                overflow: hidden;
              }
            }
            .dots-text {
              font-size: 13px;
              color: @black-color;
            }
          }
        }
      }
    }

    .input-phone-number {
      &.is-valid {
        input {
          border-color: @primary-color !important;
        }

        &:hover {
          input {
            border-color: @primary-color !important;
          }
        }
      }

      &.is-focused {
        input {
          box-shadow: unset !important;
          border-color: @primary-color !important;
          border: 1px solid;
        }

        &:hover {
          input {
            border-color: @primary-color !important;
          }
        }
      }
      label {
        display: none;
      }
      input {
        border-top-right-radius: 8px !important;
        border-bottom-right-radius: 8px !important;
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
        border: 1px solid #dcdfe6;
        background-color: #fbfbfb;
        padding: 10px 10px 10px 10px !important;
      }
      &:hover {
        input {
          border-color: #c0c4cc !important;
        }
      }
    }
  }

  .custom-option {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 3px 0px;

    img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      margin-right: 6px;
    }
    span {
      font-size: 13px;
      font-weight: 400;
      color: @soft-black-color;
    }
  }

  .el-button-group {
    .el-button {
      border-radius: 0px !important;
      &:first-child {
        border-top-left-radius: 8px !important;
        border-bottom-left-radius: 8px !important;
      }
      &:last-child {
        border-top-right-radius: 8px !important;
        border-bottom-right-radius: 8px !important;
      }
    }
  }

  .el-input__inner {
    border-radius: 8px !important;
  }

  .el-textarea__inner {
    border-radius: 8px !important;
  }

  .el-input__count,
  .el-input__count-inner {
    font-size: 12px !important;
  }

  .el-checkbox,
  .el-radio {
    font-weight: 400 !important;
  }

  .el-input-number {
    align-items: center;
    justify-content: center;
    display: inline-flex !important;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:focus-within {
      .el-input-number__increase,
      .el-input-number__decrease {
        border-color: @primary-color !important;
      }

      &:hover {
        .el-input-number__increase,
        .el-input-number__decrease {
          border-color: @primary-color !important;
        }

        & > .el-input {
          input {
            border-color: @primary-color !important;
          }
        }
      }

      & > .el-input {
        input {
          border-color: @primary-color !important;
        }
      }
    }

    &:hover {
      .el-input-number__increase,
      .el-input-number__decrease {
        border-color: #c0c4cc !important;
      }

      input {
        border-color: #c0c4cc !important;
      }
    }

    .el-input-number__increase {
      border-radius: 0 8px 8px 0 !important;
      height: calc(~"100% - 2px") !important;
      justify-content: center;
      align-items: center;
      display: flex;
      z-index: auto !important;
      border: 1px solid #dcdfe6;
      right: 0px !important;
      top: 0px;
    }

    .el-input-number__decrease {
      border-radius: 8px 0 0 8px !important;
      height: calc(~"100% - 2px") !important;
      justify-content: center;
      align-items: center;
      display: flex;
      z-index: auto !important;
      border: 1px solid #dcdfe6;
      left: 0px !important;
      top: 0px;
    }

    > .el-input {
      width: calc(~"100% - 82px") !important;

      input {
        border-left: unset !important;
        border-right: unset !important;
        border-radius: unset !important;

        &:focus {
          border-color: @primary-color !important;
        }

        &:hover {
          border-color: #c0c4cc !important;
        }
      }
    }
  }

  .el-button {
    border-radius: 8px !important;

    .prefix-icon {
      margin-right: 6px;
    }

    .suffix-icon {
      margin-left: 6px;
    }

    &.is-circle {
      border-radius: 50% !important;
    }

    &.is-round {
      border-radius: 30px !important;
    }

    i {
      &.fa,
      &.fab,
      &.fad,
      &.fal,
      &.far,
      &.fas {
        font-family: "Font Awesome 5 Free" !important;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        line-height: 1;
      }
    }
  }

  .el-select-dropdown {
    position: absolute;
    z-index: 1001;
    border: 1px solid #e4e7ed;
    border-radius: 8px !important;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin: 5px 0;
  }

  .quill-editor {
    background-color: transparent;

    &:focus-within {
      .ql-toolbar,
      .ql-container {
        border-color: @primary-color !important;
      }

      &:hover {
        .ql-toolbar,
        .ql-container {
          border-color: @primary-color !important;
        }

        & > .el-input {
          input {
            border-color: @primary-color !important;
          }
        }
      }
    }

    &:hover {
      .ql-toolbar,
      .ql-container {
        border-color: #c0c4cc !important;
      }
    }

    .ql-toolbar {
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      border: 1px solid #dcdfe6 !important;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      background-color: @white-color;
    }

    .ql-container {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      border: 1px solid #dcdfe6 !important;
      background-color: @white-color;
      border-top: 0px !important;
    }
  }

  .registration-question {
    width: 100%;
    transition: 1s;
    margin-top: 18px;
    text-align: left;

    .el-upload-dragger {
      width: 100% !important;
      border-radius: 8px;
    }

    .upload-registration {
      .el-upload {
        width: 100%;
      }
    }

    .profile-picture-upload {
      .el-upload {
        display: flex;
        flex-direction: column;
        align-items: center;
        .el-upload-dragger {
          aspect-ratio: 1 / 1;
          height: auto !important;
          border-radius: 50%;
          max-width: 150px;

          .el-icon-upload {
            font-size: 50px;
            margin: 12px 0 12px;
          }

          .el-upload__text {
            font-size: 13px;
          }
        }
      }
      .el-upload__tip {
        text-align: center;
      }
    }

    .el-select {
      width: 100%;
    }

    .sub-title {
      color: #292f3b;
      font-weight: 500;
      margin-bottom: 8px;
      font-size: 14px;

      span {
        color: @danger-color;
      }
    }

    .hint-text {
      color: #505763;
      font-size: 13px;
      font-weight: 400;
      margin-top: 3px;
      display: block;
    }

    .choice-questions {
      margin: 12px 0px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      gap: 0.5rem;
    }

    .el-input-number {
      width: 100% !important;
    }

    .el-date-editor {
      width: 100% !important;
    }

    .rate-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      min-height: 45px;

      .el-slider {
        width: 100%;
      }
    }
  }

  .question-builder-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    span {
      color: #292f3b;
      font-size: 14px;

      b {
        color: #292f3b;
        font-weight: 500;
      }
    }

    .question-builder-button {
      color: white;

      span {
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/participants/Questions.vue